import { useEffect, useState } from "react";
import { MissingVm } from "../../service/sync.service";
import Button from "../Button";
import { CustomModal } from "../CustomModal";
import { Actions, Description, List, Row, Warning } from "./style";

interface SyncDeletionModalProps {
    vms: MissingVm[];
    isDeleting: boolean;
    onCancel: () => void;
    onConfirm: (serverIds: string[]) => void;
}

export const SyncDeletionModal = ({ vms, isDeleting, onCancel, onConfirm }: SyncDeletionModalProps) => {
    const [selectedIds, setSelectedIds] = useState<string[]>([]);

    useEffect(() => {
        setSelectedIds(vms.map(vm => vm.id));
    }, [vms]);

    const toggle = (id: string) => {
        setSelectedIds(current => current.includes(id)
            ? current.filter(item => item !== id)
            : [...current, id]);
    };

    return (
        <CustomModal
            title="Máquinas não encontradas no vCenter"
            isOpen={vms.length > 0}
            onClose={onCancel}
        >
            <Description>
                As máquinas abaixo estão cadastradas no painel, mas não existem mais no vCenter.
                Selecione as que devem ser removidas do painel.
            </Description>
            <Warning>
                A exclusão remove o registro, o histórico de status e os agendamentos vinculados,
                e libera o IP reservado. Nada é apagado no vCenter.
            </Warning>
            <List>
                {vms.map(vm => (
                    <Row key={vm.id}>
                        <label>
                            <input
                                type="checkbox"
                                checked={selectedIds.includes(vm.id)}
                                onChange={() => toggle(vm.id)}
                                disabled={isDeleting}
                            />
                            <strong>{vm.alias || vm.name}</strong>
                            <span>{vm.name}</span>
                            <span>{vm.ip || 'sem IP'}</span>
                        </label>
                    </Row>
                ))}
            </List>
            <Actions>
                <Button variant="secondary" onClick={onCancel}>Manter todas</Button>
                <Button
                    variant="primary"
                    isLoading={isDeleting}
                    onClick={() => selectedIds.length > 0 && onConfirm(selectedIds)}
                >
                    {`Excluir selecionadas (${selectedIds.length})`}
                </Button>
            </Actions>
        </CustomModal>
    );
};
